import { render } from "./PuzzlesView.vue?vue&type=template&id=4a9baf59"
import script from "./PuzzlesView.vue?vue&type=script&lang=js"
export * from "./PuzzlesView.vue?vue&type=script&lang=js"

import "./PuzzlesView.vue?vue&type=style&index=0&id=4a9baf59&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__